export type ConversationInboxChannel = "whatsapp" | "instagram" | "messenger";

export function buildConversationInboxUrl(options: {
  conversationId: string;
  channel?: ConversationInboxChannel;
  integrationId?: string | null;
}): string {
  const params = new URLSearchParams();
  params.set("conversation_id", options.conversationId);
  if (options.channel) {
    params.set("channel", options.channel);
  }
  if (options.integrationId) {
    params.set("integration_id", options.integrationId);
  }
  return `/conversations?${params.toString()}`;
}
